window.currentTagHead = false;
window.upFont = [];
(function ($) {

RVwys.plugin['FormatFont'] = true;
RVwys.listFontDefault = ['"Open Sans"'];
RVwys.FormatFont= {};

var tagVal = {};
tagVal['h6'] = 'Header 6';
tagVal['h5'] = 'Header 5';
tagVal['h4'] = 'Header 4';
tagVal['h3'] = 'Header 3';
tagVal['h2'] = 'Header 2';
tagVal['h1'] = 'Header 1';
tagVal['p'] = 'Normal Text';

	/*
	$(document).bind('beforeSave',function(){
		alert('fontformat beforeSave')
	})

	$(document).bind('afterSave',function(){
		alert('fontformat afterSave')
	})

	$(document).bind('completeSave',function(){
		alert('fontformat completeSave')
	})
*/
 $(document).bind('editorReady',function(){
	
	 
	 $(".Font dd ul,.mini_Font dd ul").ready(function(){
		RVwys.FormatFont.ListFont();
	 });
	 


	 $('.setFontSize').click(function(){
			 var cmd = $(this).attr('cmd');
			 var fontVal = $(this).attr('set');
			 if(RVwys.currentEditor) {
				 var tagParent = RVwys.getRangeParent();
				 if (tagParent.get(0).tagName.toLowerCase() == 'font') {
					 $(tagParent).css('fontSize', fontVal);
					 var fo = frameBody.contentWindow;
				     fo.RVwys.history.add();
				 } else {
					 RVwys.setFontSize(cmd, fontVal);					 
				 }
			 }
	 });
	 
	 

	 $('.setSize').click(function(){
		 var cmd = $(this).attr('cmd');
		 var fontVal = $(this).attr('set');
		 if(RVwys.currentEditor) {
			var tagParent = RVwys.getRangeParent();
			 var range = RVwys.getRange();
			 console.log('//////////////////////////');
			 if (currentTagHead) {
				 var curClasstagH = currentTagHead.attr('class');
				 var curCsstagH = currentTagHead.attr('style');
				 
				 console.log('use head-->'+currentTagHead.get(0).tagName);
				 
				 RVwys.execDesignMode(cmd, false, fontVal);	
				 var oFocusNode = RVwys.currentEditor.getSelection().focusNode.parentNode;
				 console.log($(oFocusNode).closest(fontVal));
				 parent.currentTagHead = $(oFocusNode).closest(fontVal).attr("class",curClasstagH).attr("style",curCsstagH);
				 
				 $(oFocusNode).css({'font-size':''});
				 parent.$(".FontSize dt a span,.mini_FontSize dt a span").html('<span>none</span>');
				 RVwys.history.add();
			 }
		 }
 });


 $('.addFont').click( function(){
	window.upFont = [...wex.addFont];
	
	var options   = {
		bgclose: false,
        keyboard: false,
        modal: false,
		};
	var modal = UIkit.modal.dialog(([
		`<div class="uk-margin uk-modal-header"><h2>Add Font</h2><span class="uk-modal-close uk-icon-close"></span></div>
			<div class="uk-margin uk-modal-content">${$('.addFontDetail').html()}</div>
		<div class="uk-modal-footer uk-text-left clear">
		<button class="uk-button uk-button-success  js-modal-confirm">${rvLang('Ok')}</button>
		<button class="uk-button js-modal-confirm-cancel">${rvLang('Cancel')}</button>
		</div>`,
		]).join(""),options);


		RVwys.getNewFont(modal.element);

		modal.element.find('.btnAddFont').click( ()=> {


			var AddFont = modal.element.find('#NameFont').val();
			var haveFont = ($.inArray(AddFont,window.upFont) !='-1')?false :true ;
			var fontLength = window.upFont.length;

			if (AddFont && fontLength < '6') {
				
				if (haveFont) {
	
					var families = [`${AddFont}`];
					var isLoading = modal.element.find('.loadingValidate');
					var btnAddFont = modal.element.find('.btnAddFont');
	
	
					WebFont.load({
						"google": {
							"families": families,
						},
						context: window.frames.frameBody.contentWindow,
						classes: false,
						loading: function () {
							console.log('loading');
							isLoading.show();
							btnAddFont.attr('disabled','');
						},
						active: function () {
							console.log('active');
	
							window.upFont.push(AddFont);
							modal.element.find('.AddFont-list').append(`<div>
							<span>${AddFont}</span><a href="javascript:void(0)" class="DeleteFont" data-name="${AddFont}"><i class="uk-icon uk-icon-times-circle right"></i></a></div>`);
	
							modal.element.find('#NameFont').val('');
							btnAddFont.removeAttr('disabled');
							isLoading.hide();
							modal.element.find("#msgError .uk-alert-close").click();

						},
						inactive: function () {
							console.log('inactive');
						},
						fontloading: function (fontFamily, fontDescription) {
							console.log('fontloading: ' + fontFamily + ' (' + fontDescription + ')');
						},
						fontactive: function (fontFamily, fontDescription) {
							console.log('fontactive: ' + fontFamily + ' (' + fontDescription + ')');
						},
						fontinactive: function (fontFamily, fontDescription) {
							console.log('fontinactive: ' + fontFamily + ' (' + fontDescription + ')');
							btnAddFont.removeAttr('disabled');
							isLoading.hide();
							console.inline.error({
								'target': modal.element.find("#msgError") ,
								'title':Error,
								'text': 'This font name does not exist in Google Font or you may recheck the correct name.',
								'text': 'The '+ fontFamily +' is not Google Font. Font name is case-sensitive. Please make sure you enter the correct name.',

								});
	
	
						}
					});
				}else{
							console.inline.error({
								'target': modal.element.find("#msgError") ,
								'title':Error,
								'text':  'Oh! You already added this font in your website a while ago!',
								});
				}


			}else{

				var msg = 'Please insert a font name.';
				
				if (AddFont && fontLength < '7') {
					msg = 'You can add up to 5 maximum font types.';
				}

				console.inline.error({
					'target': modal.element.find("#msgError") ,
					'title':Error,
					'text':  msg,
					});

			}
		});

		modal.element.find('.js-modal-confirm').click( ()=> {

			var upFont = window.upFont;
			wex.addFont = upFont;
			updateFontDB(upFont);

			modal.hide();
	
			
		});

		modal.element.find('.js-modal-confirm-cancel').click( ()=> {
			modal.hide();
		});

	modal.show();

	function updateFontDB(arrFont) {

		arrFont = {
			name:arrFont
		};

		$.ajax({
			type: 'POST',
			url:'/admin/wysiwyg/addfont',
			data:arrFont,
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				success: function(data) {

					FormatFontrender(data);
					console.pop.success({
						text:'Add Font Success.'
					});

					RVwys.FormatFont.ListFont();
					RVwys.SiteTheme.ListFont();
				}
			 });
	}

 });
 
 });
 RVwys.designViewAddEvent('mouseup keydown',function(e){


	 var tagParent = RVwys.getRangeParent();
	 if (tagParent) {
		 //fontStyle = $('#selected_body').css('font-family').replace(/\"/img,'');
		 var fontStyle = 'Default';
		 var setFontSelect = '<span style="font-family:'+fontStyle+'">'+fontStyle+'</span>';
		 
		 if (tagParent.get(0).tagName.toLowerCase() == 'font' &&  tagParent.attr('face') != undefined) {

			console.log(tagParent.attr('face'));
			
			 if(tagParent.attr('face') != '') {	 
				 setFontSelect = '<span style="font-family:' + tagParent.attr('face') + ';">' + tagParent.attr('face') + '</span>';
			 }
		 }

		 parent.$(".Font dt a span,.mini_Font dt a span").html(setFontSelect);
	 }
 });

 RVwys.designViewAddEvent('mouseup',function(e){
	 var tagParent = RVwys.getRangeParent();
	 if (tagParent) {
		 var tagParentName = tagParent.get(0).tagName.toLowerCase();
	
		 var setFontSelect = '<span style="padding:0px; margin:0px;">size</span>';
		 switch (tagParentName) {
		 	case 'font':
			var m = Math.ceil(parseFloat(tagParent.css('fontSize'))) + 'px';
			setFontSelect = 
				 '<span style="font-size:' + m + ';padding:0px; margin:0px;">' + m + '</span>';
			break;
		 	default:
			var m ='size';
			break;
		}
		 parent.$(".FontSize dt a span,.mini_FontSize dt a span").html(m);
	 }
	 
console.log($(e.target));

	 //var tagParent = RVwys.getRangeParent();
	 var tagParent = RVwys.getParentByTags($(e.target),{'h6':true,'h5':true,'h4':true,'h3':true,'h2':true,'h1':true,'p':true});
	 //console.log('head->'+tagParent.get(0).tagName)
	 if (tagParent) {
		 var tagParentName = tagParent.get(0).tagName.toLowerCase();
		 var setFontSelect = '<span style="padding:0px; margin:0px;">Normal Text</span>';
		 console.log('tagParentName'+tagParentName);
		 console.log('currentTagHead'+currentTagHead);
		 switch (tagParentName) {
			case 'h6':case 'h5':case 'h4':case 'h3':case 'h2':case 'h1':case 'p':
				var m = tagVal[tagParentName];
				setFontSelect = '<'+ tagParentName + ' style="padding:0px; margin:0px;">' + m + '</' + tagParentName + '>';
				parent.currentTagHead = tagParent;
				console.log('add head'+parent.currentTagHead);
				break;
			default:
				var m ='Normal Text';
				break;
		}
		 parent.$(".TagHead dt a span").html(m);
	 }
 
 });
 
 RVwys.setFontSize = function(cmd, fontVal) {

	 if (cmd == 'fontSize') {
		 this.execDesignMode(cmd, false, '7');
		 $(this.currentiFrame).find('font').each(function(){
			var issize = $(this).attr('size');
			if (issize == '7') {
				$(this).removeAttr('size');
				$(this).css('fontSize', fontVal);

				var fo = frameBody.contentWindow;
				fo.RVwys.history.add();					
			}
		 });
	 } else {
		var range = RVwys.getRange();
		 if (range != '' ) {
			 if (range.startContainer) {
				 RVwys.insertHTML($('<'+fontVal+'>'+range+'</'+fontVal+'>'));
			 } else {
				 this.execDesignMode(cmd, false, fontVal);			
			 }
		 } else {
			 this.execDesignMode(cmd, false, fontVal);			 
		 }
	 }
	 
 };


 RVwys.getNewFont = function(elem){

	 elem.find('.AddFont-list');

	// wex.addFont

	try{
		if (wex.addFont != undefined) {	
			$.each(wex.addFont, function(k,v){

				var iconDele = `<div data-fontKey="${k}">
				<span>${v}</span>
				<a href="javascript:void(0)" class="DeleteFont" data-name="${v}"><i class="uk-icon uk-icon-times-circle right"></i></a>
				</div>`;
				if (k == 0){
					iconDele = `<div data-fontKey="${k}"><span>${v}</span></div>`;
				}
				elem.find('.AddFont-list').append(iconDele);
			

			});

			elem.find('.DeleteFont').click(function () {  
				var nameFont = $(this).data('name');
				DeleteFont(nameFont);
			});
		}

	
	}catch(e){
		console.log(e);
	}


 };

 function DeleteFont(nameFont) {
	 var isKey = $.inArray(nameFont,window.upFont);
	 window.upFont.splice(isKey,1);
	 $(`[data-fontKey=${isKey}]`).remove();
 }

 
 RVwys.FormatFont.ListFont =function(){

	var strFont ='<li><a href="javascript:void(0)" class="setfont" cmd="FontName" set="Verdana"></a></li>';
	//add font default
	strFont +='<li><a href="javascript:void(0)" class="setfont" cmd="FontName" set="Default"><span style="font-family:;">Default</span></a></li>';

	
	try{
	   if (parent.wex.addFont != undefined) {	
		   $.each(parent.wex.addFont, function(k,v){
			   strFont +='<li class="rvfont"><a href="javascript:void(0)" class="setfont" cmd="FontName" set="'+v+'"><span style="font-family:'+v+'">'+v+'</span></a></li>';
		   });
	   }
	   //strFont += '<li class="rvfont"></li>';
		if (parent.wex.aFont != undefined) {	
			$.each(parent.wex.aFont, function(k,v){
				strFont +='<li><a href="javascript:void(0)" class="setfont" cmd="FontName" set="'+v+'"><span style="font-family:'+v+'">'+v+'</span></a></li>';
			});
		}
	}catch(e){
		console.log(e);
	}
	
		$(".Font dd ul,.mini_Font dd ul").html(strFont)
		.find('.setfont').click(function(){
			var oNotactiveTag = {};
			oNotactiveTag['h6'] = true;
			oNotactiveTag['h5'] = true;
			oNotactiveTag['h4'] = true;
			oNotactiveTag['h3'] = true;
			oNotactiveTag['h2'] = true;
			oNotactiveTag['h1'] = true;
			var cmd = $(this).attr('cmd');
		   
			
			if(RVwys.currentEditor) {
				
				if($(this).attr('set') == 'Default'){
					var tagParent = RVwys.getRangeParent();
				   
				   if($(tagParent).closest('font[face]').attr('face')){
					   $(tagParent).closest('font[face]').contents().unwrap();
					   return;
				   }
				}
				
				RVwys.execDesignMode($(this).attr('cmd'), false, $(this).attr('set'));
				$(".Font dt a span,.mini_Font dt a span").html($(this).attr('set'));
			}
			$(".Font dd ul,.mini_Font dd ul").hide();
	});

}
 
})(jQuery);